export const DEFAULT_ITEMS_COUNT = 20;
export const PAGE_SIZE_OPTIONS: Array<number> = [20, 50, 100];
